import { render } from "./ForgetPasswordPage.vue?vue&type=template&id=36147868"
import script from "./ForgetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordPage.vue?vue&type=script&lang=js"

import "./ForgetPasswordPage.vue?vue&type=style&index=0&id=36147868&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__